export enum ModulePageType {
	DOCUMENTS = 'DOCUMENTS', // DOCUMENTS
	ARTICLES = 'ARTICLES', // ARTICLES
	GENERAL = 'GENERAL', // QUESTIONS
	TASKS = 'TASKS', // TASKS
	LINK = 'LINK', // LINK
	CV = 'CV', // CV
}
